import { MessageCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

function normalizePhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("90")) return `+${digits}`;
  if (digits.startsWith("0")) return `+90${digits.slice(1)}`;
  if (digits.length === 10) return `+90${digits}`;
  return `+${digits}`;
}

export default function WhatsAppSupport() {
  const { user } = useAuth();
  const supportPhone = process.env.REACT_APP_WHATSAPP_PHONE || "905317491456";
  const registeredPhone = normalizePhone(user?.phone);
  const message = encodeURIComponent(
    user
      ? `Merhaba Sevinç Outdoor, destek almak istiyorum. Ad Soyad: ${user.fullName || "-"}. Kayıtlı telefonum: ${registeredPhone || "belirtilmemiş"}.`
      : "Merhaba Sevinç Outdoor, destek almak istiyorum."
  );

  return (
    <a
      href={`https://wa.me/${supportPhone}?text=${message}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-emerald-600 px-5 py-4 text-sm font-bold text-white shadow-2xl ring-4 ring-white/70 transition hover:-translate-y-0.5 hover:bg-emerald-700"
      aria-label="WhatsApp destek hattı"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline">WhatsApp Destek</span>
    </a>
  );
}
